import { Row, Col, Card, Typography, Image } from "antd";
import CapitalRaised from "../../../assets/icons/capital_raised.svg";
import DealsFunded from "../../../assets/icons/deals_funded.svg";
import AverageFunding from "../../../assets/icons/avg_funding.svg";
import TimeOnPlatform from "../../../assets/icons/time_on_platform.svg";
import TotalReturns from "../../../assets/icons/return_to_investors.svg";
import TimelyRepayment from "../../../assets/icons/repay_rate.svg";
import { GLOBAL_CONSTANTS } from "../../../constants/constants";
import { formatToLacCr } from "../../../helpers/helpers";

const { Text } = Typography;

const formatStatValue = (val, isCurrency = false) => {
  if (val === undefined || val === null || val === "") {
    return GLOBAL_CONSTANTS.NIL;
  }
  if (isCurrency) {
    if (Number.isNaN(Number(val))) {
      return GLOBAL_CONSTANTS.NIL;
    }
    const formatted = formatToLacCr(Number(val));
    return formatted || GLOBAL_CONSTANTS.NIL;
  }
  return val;
};

const Overview = ({ deal }) => {
  const timelyRate = deal?.beStats?.timelyRepaymentRate;
  const timelyRateFormatted =
    timelyRate !== undefined &&
    timelyRate !== null &&
    timelyRate !== "" &&
    !Number.isNaN(Number(timelyRate))
      ? `${timelyRate} %`
      : GLOBAL_CONSTANTS.NIL;

  const beOverviewStats = [
    {
      title: "Capital Raised",
      value: formatStatValue(deal?.beStats?.capitalRaised, true),
      icon: CapitalRaised,
      color: "#FFF3EB",
    },
    {
      title: "Deals Funded",
      value: formatStatValue(deal?.beStats?.dealsFunded),
      icon: DealsFunded,
      color: "#EBFAF3",
    },
    {
      title: "Average Funding Per Month",
      value: formatStatValue(deal?.beStats?.avgFundingPerMonth, true),
      icon: AverageFunding,
      color: "#FFF6D6",
    },
    {
      title: "Time on Platform",
      value: formatStatValue(deal?.beStats?.timeOnPlatform),
      icon: TimeOnPlatform,
      color: "#FFF3EB",
    },
    {
      title: "Total Returns Paid to Investors",
      value: formatStatValue(deal?.beStats?.totalReturnsToInv, true),
      icon: TotalReturns,
      color: "#EBFAF3",
    },
    {
      title: "Timely Repayment Rate",
      value: timelyRateFormatted,
      icon: TimelyRepayment,
      color: "#FFF6D6",
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {beOverviewStats.map((item) => (
        <Col xs={24} sm={12} lg={8} key={item.title}>
          <Card className="be-overview-stats-card">
            <div className="be-overview-stats-content">
              <div
                className="be-overview-stats-icon"
                style={{
                  backgroundColor: `${item.color}`,
                }}
              >
                <Image src={item.icon} preview={false} />
              </div>

              <div>
                <Text className="be-overview-stats-title">{item.title}</Text>

                <div className="be-overview-stats-value">{item.value}</div>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default Overview;
